var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("Sorry, we couldn't find what you were looking for")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/home"}},[_vm._v("Go Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }